import { render, staticRenderFns } from "./EvidenceForceConfirmModal.vue?vue&type=template&id=7b74742a&scoped=true"
import script from "./EvidenceForceConfirmModal.vue?vue&type=script&lang=js"
export * from "./EvidenceForceConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./EvidenceForceConfirmModal.vue?vue&type=style&index=0&id=7b74742a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74742a",
  null
  
)

export default component.exports